<template>
  <v-container v-if="fund">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ fund.name }}
      </v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="downloadPdf" :loading="loading">
          {{ $t("fund.protocol.downloadPdf") }}
        </v-btn>
      </v-col>

      <v-col cols="12">
        <DataTable :fund="fund" />
      </v-col>

      <v-col cols="12">
        <MinimalRequirements :requirements="fund.minimalRequirements" />
      </v-col>

      <v-col v-if="fund.stepModel" cols="12">
        <StepModelRequirements :requirements="fund.stepModelRequirements" />
      </v-col>

      <v-col cols="12">
        <v-btn color="secondary" @click="$router.go(-1)">
          {{ $t("action.back") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import getPdfMake from "@/utils/getPdfMake";
import DataTable from "@/components/Fund/DataTable";
import FundProtocolQuery from "@/gql/queries/FundProtocolQuery.gql";
import generateProtocolPdfData from "@/utils/Protocol/generateProtocolPdfData";
import generateProtocolPdfData2024 from "@/utils/Protocol/2024/generateProtocolPdfData";
import MinimalRequirements from "@/components/User/Fund/Protocol/MinimalRequirements";
import StepModelRequirements from "@/components/User/Fund/Protocol/StepModelRequirements";

export default {
  components: {
    DataTable,
    MinimalRequirements,
    StepModelRequirements,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      fund: null,
      loading: false,
    };
  },

  apollo: {
    fund: {
      query: FundProtocolQuery,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },

  methods: {
    async downloadPdf() {
      this.loading = true;

      const pdfMake = await getPdfMake();
      const prefix = this.$t("fund.protocol.file.name");

      let pdfData = null;

      if (this.fund.auditPeriod.year >= 2024) {
        pdfData = generateProtocolPdfData2024(this.fund, false);
      } else {
        pdfData = generateProtocolPdfData(this.fund, false);
      }

      pdfMake.createPdf(pdfData).download(`${prefix}${this.fund.auditPeriod.year + 1}_${this.fund.name}.pdf`);

      this.loading = false;
    },
  },
};
</script>
